const keyMirror = (list: string[]) =>
  list.reduce((acc, it: string) => {
    const keys =
      it.includes('FETCH') || it.includes('PROMISE')
        ? {
            [`${it}_START`]: `${it}_START`,
            [`${it}_ERROR`]: `${it}_ERROR`,
            [`${it}_SUCCESS`]: `${it}_SUCCESS`,
          }
        : {};

    return {
      ...acc,
      ...keys,
      [it]: it,
    };
  }, {});

export default keyMirror;
